<template>
  <div class="fa">
    <div class="dyh-line-group">
      <div>
        <b class="dyh-line-group-label">商 户 进 件</b>
        <el-input style="margin-left: 20px;" size="small" type="text" v-model="searchMchName" @change="searchMerchant"
          placeholder="请输入店铺名称模糊查询"></el-input>
      </div>
      <el-button type="primary" plain size="small" style="width: 150px" @click="createMch('')">新 建 门 店</el-button>
    </div>
    <mchTable ref="mchTableRef" @mchTableAction="mchTableAction"></mchTable>
    <el-dialog title="商户进件" :visible.sync="feedDialog" width="80%" top="4vh" :before-close="handleClose">
      <div class="box" :class="el_steps === 'el-steps' ? '' : 'box-small'" shadow="always">
        <div style="" class="el-steps-fa">
          <el-steps :class="el_steps" style="" :active="active" finish-status="success">
            <el-step title="资质信息"></el-step>
            <el-step title="基础信息"></el-step>
            <el-step title="结算信息"></el-step>
            <el-step title="核对校验"></el-step>
          </el-steps>
        </div>
        <div>
          <!-- 表单详情 -->
          <div class="card-form" v-if="feedDialog">
            <div v-show="active === 0">
              <div :style="el_steps === 'el-steps' ? 'height:400px' : 'height:360px'">
                <el-scrollbar wrapStyle="overflow-x:hidden;" style="height: 100%">
                  <el-form size="mini" status-icon :model="shop_info" :rules="baserules" ref="baseForm"
                    class="el-form-pc" label-width="180px" label-position="right">
                    <el-form-item class="validate-must" label="店铺类型：" prop="mch_type">
                      <el-radio-group v-model="shop_info.mch_type">
                        <el-radio-button :label="1">商超零售商</el-radio-button>
                        <el-radio-button :label="2">批发供应商</el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="营业执照照片：" prop="img_license">
                      <uploadImg class="uploadImg" :imgTitle="'yyzz'" :mediaNo="shop_info.img_license"
                        @getReturn="getReturn" @removeImg="removeImg">
                        <template slot="centerName"> 营业执照 </template>
                      </uploadImg>
                    </el-form-item>
                    <el-form-item label="店铺密码：" prop="pass_word">
                      <el-input v-model="shop_info.pass_word" show-password placeholder="店铺登录需要的参数"></el-input>
                    </el-form-item>
                    <el-form-item label="店铺名称：" prop="mch_name">
                      <el-input v-model="shop_info.mch_name" placeholder="进件的店铺名称，可以通过营业执照识别"></el-input></el-form-item>
                    <el-form-item label="店铺简称：" prop="sub_name">
                      <el-input v-model="shop_info.sub_name" placeholder="商户简称"></el-input></el-form-item>
                    <el-form-item label="营业执照id：" prop="license_code">
                      <el-input v-model="shop_info.license_code"
                        placeholder="营业执照注册号，可以通过营业执照识别"></el-input></el-form-item>
                    <el-form-item label="营业执照有效期：" prop="license_start_date">
                      <el-col :span="8">
                        <el-date-picker clearable type="date" placeholder="开始日期" v-model="shop_info.license_start_date"
                          style="width: 100%" @change="getDate($event, 'license_start_date')"></el-date-picker>
                      </el-col>
                      <el-col :span="1" style="text-align: center;">—</el-col>
                      <el-col :span="8">
                        <el-date-picker clearable type="date" placeholder="截止日期(长期则不选)"
                          v-model="shop_info.license_expire_in" @change="getDate($event, 'license_expire_in')"
                          style="width: 100%"></el-date-picker>
                      </el-col>
                    </el-form-item>
                    <el-form-item label="店铺地址：" prop="address"><el-input v-model="shop_info.address"
                        placeholder="填写店铺所在地的详细地址，可以通过营业执照识别"></el-input></el-form-item>
                    <el-form-item label="商户类型：" prop="merchant_type">
                      <el-select style="width: 460px;" class="qualification-type-select"
                        v-model="shop_info.merchant_type" placeholder="选择店铺的资质类型">
                        <el-option v-for="item in merchant_type_options" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="商户类型：" prop="business_scope">
                    <el-select style="width: 460px;" v-model="shop_info.business_scope" filterable
                      placeholder="经营范围(可通过输入的内容搜索)">
                      <el-option v-for="item in MCC" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item> -->
                    <el-form-item label="店铺省市区：" prop="address_code">
                      <el-cascader style="width: 460px;" placeholder="选择店铺的省市区" v-model="shop_info.address_code"
                        class="qualification-type-select" :options="provincearr" @change="shophandleChange"
                        :filterable="true" :clearable="true"></el-cascader>
                    </el-form-item>

                    <el-form-item label="店铺门头照：" prop="img_door">
                      <uploadImg class="uploadImg" :mediaNo="shop_info.img_door" :imgTitle="'store_entrance'"
                        @getReturn="getReturn" @removeImg="removeImg">
                        <template slot="centerName"> 店铺门头照 </template>
                      </uploadImg>
                    </el-form-item>

                    <el-form-item label="店铺内景照片：" prop="img_in_door">
                      <uploadImg class="uploadImg" :mediaNo="shop_info.img_in_door" :imgTitle="'indoor'"
                        @getReturn="getReturn" @removeImg="removeImg">
                        <template slot="centerName"> 店铺内景照片 </template>
                      </uploadImg>
                    </el-form-item>
                    <el-form-item label="收银台照片：" prop="img_cashier">
                      <uploadImg class="uploadImg" :mediaNo="shop_info.img_cashier" :imgTitle="'cashier'"
                        @getReturn="getReturn" @removeImg="removeImg">
                        <template slot="centerName"> 收银台照片 </template>
                      </uploadImg>
                    </el-form-item>
                    <div style="height: 20px;"></div>
                    <!-- <el-form-item label="收银台照片：" prop="img_cashier">
                    <uploadImg class="uploadImg" :imgTitle="'cashier'" @getReturn="getReturn" @removeImg="removeImg">
                      <template slot="centerName"> 收银台照片 </template>
                    </uploadImg>
                  </el-form-item> -->
                  </el-form>
                </el-scrollbar>
              </div>
            </div>
            <div v-show="active === 1">
              <div :style="el_steps === 'el-steps' ? 'height:400px' : 'height:360px'">
                <el-scrollbar wrapStyle="overflow-x:hidden;" style="height: 100%">
                  <el-form size="mini" :model="shop_info" :rules="legalrules" ref="legalForm" label-width="180px"
                    label-position="right：">
                    <el-form-item label="法人身份证：" prop="img_legal_id_front">
                      <div style="display: flex;height: 168px;">
                        <uploadImg class="uploadImg" :imgTitle="'zm'" :mediaNo="shop_info.img_legal_id_front"
                          @getReturn="getReturn" @removeImg="removeImg" style="display: inline-block">
                          <template slot="centerName"> 法人身份证正面 </template>
                        </uploadImg>
                        <uploadImg class="uploadImg" :imgTitle="'fm'" @getReturn="getReturn"
                          :mediaNo="shop_info.img_legal_id_back" @removeImg="removeImg"
                          style="display: inline-block; margin-left: 10px">
                          <template slot="centerName"> 身份证反面照片 </template>
                        </uploadImg>
                      </div>

                    </el-form-item>
                    <!-- <el-form-item label="开户银行卡照片：" prop="img_bank_card">
                    <uploadImg
                      class="uploadImg"
                      :imgTitle="'bank'"
                      @getReturn="getReturn"
                      @removeImg="removeImg"
                    >
                      <template slot="centerName">
                        银行卡
                      </template>
                    </uploadImg>
                  </el-form-item> -->
                    <el-form-item label="法人姓名：" prop="legal_person_name"><el-input v-model="shop_info.legal_person_name"
                        placeholder="请填写法人姓名，可通过法人身份证识别"></el-input></el-form-item>
                    <el-form-item label="法人身份证号：" prop="legal_person_id"><el-input v-model="shop_info.legal_person_id"
                        placeholder="请填写法人发生在号，可通过法人身份证识别"></el-input></el-form-item>
                    <el-form-item label="法人身份证有效期：" prop="legal_person_id_start_date">
                      <el-col :span="8">
                        <el-date-picker type="date" placeholder="开始日期" v-model="shop_info.legal_person_id_start_date"
                          style="width: 100%" @change="getDate($event, 'legal_person_id_start_date')"></el-date-picker>
                      </el-col>
                      <el-col :span="1" style="text-align: center;">—</el-col>
                      <el-col :span="8">
                        <el-date-picker type="date" placeholder="截止日期(长期则不选)"
                          v-model="shop_info.legal_person_id_expire_in"
                          @change="getDate($event, 'legal_person_id_expire_in')" style="width: 100%"></el-date-picker>
                      </el-col>
                    </el-form-item>

                    <!-- <el-form-item label="联系人：" prop="contact_man"><el-input v-model="shop_info.contact_man"
                      placeholder="一般填业务员的姓名"></el-input></el-form-item> -->
                    <el-form-item label="联系人手机号：" prop="mobile_no"><el-input v-model="shop_info.mobile_no"
                        placeholder="一般填业务员的手机号码"></el-input></el-form-item>
                    <el-form-item label="店铺电话：" prop="phone">
                      <el-input v-model="shop_info.phone" placeholder="需填写店铺负责人的手机号码"></el-input></el-form-item>
                    <el-form-item label="服务电话：" prop="service_phone">
                      <el-input v-model="shop_info.service_phone" placeholder="填写店铺的客服电话"></el-input></el-form-item>
                    <!--  <el-form-item label="店铺传真："><el-input v-model="shop_info.fax"
                      placeholder="店铺传真"></el-input></el-form-item> -->
                    <el-form-item label="店铺邮箱：" prop="e_mail">
                      <el-input v-model="shop_info.e_mail" placeholder="店铺电子邮箱"></el-input>
                    </el-form-item>
                  </el-form>
                </el-scrollbar>
              </div>
            </div>
            <div v-show="active === 2">
              <div :style="el_steps === 'el-steps' ? 'height:400px' : 'height:360px'">
                <el-scrollbar wrapStyle="overflow-x:hidden;" style="height: 100%">
                  <el-form size="mini" label-width="180px" label-position="right：" :model="shop_info" :rules="bankrules"
                    ref="bankForm">
                    <el-form-item label="结算方式：" prop="wxradio">
                      <el-radio-group @change="wxradioChange" v-model="shop_info.wxradio">
                        <el-radio-button label="1">对私法人结算</el-radio-button>
                        <el-radio-button label="2">对私非法人结算</el-radio-button>
                        <el-radio-button label="3">对公账号结算</el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="开户银行卡照片：" prop="img_bank_card">
                      <uploadImg class="uploadImg" :mediaNo="shop_info.img_bank_card" :imgTitle="'bank'"
                        @getReturn="getReturn" @removeImg="removeImg">
                        <template slot="centerName"> 银行卡 </template>
                      </uploadImg>
                    </el-form-item>
                    <el-form-item label="结算银行卡号：" prop="account_code"><el-input v-model="shop_info.account_code"
                        placeholder="填写结算银行银行卡账号"></el-input></el-form-item>
                    <!-- <el-form-item label="银行名称：" prop="bank_name">
                      <el-input v-model="shop_info.bank_name" placeholder="请输入银行名称"></el-input>
                    </el-form-item> -->
                    <el-form-item label="银行名称：">
                      <el-select style="width: 460px;" v-model="shop_info.bank_alias_code" id="bank_name" filterable
                        placeholder="开户银行名称，若列表中没有则选择其他银行">
                        <el-option v-for="item in bank_option" :key="item.bank_alias_code" :label="item.bank_alias"
                          :value="item.bank_alias_code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="开户银行省市：">
                      <el-row>
                        <el-col :span="6">
                          <div id="bank_select">
                            <el-select style="max-width: 250px !important;" v-model="shop_info.bank_province" filterable
                              placeholder="选择省" @change="getCity">
                              <el-option v-for="item in province_option" :key="item.province_code"
                                :label="item.province_name" :value="item.province_code">
                              </el-option>
                            </el-select>
                          </div>
                        </el-col>
                        <el-col :span="1"></el-col>
                        <el-col :span="6">
                          <div id="bank_select">
                            <el-select v-model="shop_info.bank_city" filterable placeholder="选择市"
                              style="max-width: 250px !important;" @change="getOpenBank">
                              <el-option v-for="item in city_option" :key="item.city_code" :label="item.city_name"
                                :value="item.city_code">
                              </el-option>
                            </el-select>
                          </div>
                        </el-col>
                      </el-row>
                    </el-form-item>
                    <el-form-item label="开户行含支行名称：">
                      <el-select v-model="shop_info.open_bank_name" filterable placeholder="选择开户行支行（可模糊查询）"
                        style="width: 460px;" @change="getOpenBnakName">
                        <el-option v-for="item in open_bank_options" :key="item.bank_branch_id"
                          :label="item.bank_branch_name" :value="item.bank_branch_name">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="开户行银联号：" prop="open_bank_code">
                      <el-input v-model="shop_info.open_bank_code" placeholder="请输入开户行银联号："></el-input>
                    </el-form-item>
                    <el-form-item label="服务费率：" prop="service_charge">
                      <el-input v-model="shop_info.service_charge" placeholder="请输入服务费率（应在25~60之间）" max="60" min="25"
                        maxlength="5"></el-input>
                    </el-form-item>

                    <el-form-item label="银行卡账号名称：" prop="account_name">
                      <el-input v-model="shop_info.account_name" placeholder="填写银行卡开户账号名称"></el-input></el-form-item>
                    <el-form-item v-if="shop_info.wxradio === '2'" label="受益人身份证：" prop="img_beneficiary_id_front">
                      <div style="display: flex;height: 168px;">

                        <uploadImg class="uploadImg" :mediaNo="shop_info.img_beneficiary_id_front"
                          :imgTitle="'beneficiary_zm'" @getReturn="getReturn" @removeImg="removeImg"
                          style="display: inline-block">
                          <template slot="centerName">
                            受益人身份证正面
                          </template>
                        </uploadImg>

                        <uploadImg class="uploadImg" :mediaNo="shop_info.img_beneficiary_id_back"
                          :imgTitle="'beneficiary_fm'" @getReturn="getReturn" @removeImg="removeImg"
                          style="display: inline-block;margin-left: 10px">
                          <template slot="centerName">
                            受益人身份证反面
                          </template>
                        </uploadImg>
                      </div>
                    </el-form-item>
                    <el-form-item v-if="shop_info.wxradio === '2'" label="受益人姓名：" prop="beneficiary_name">
                      <el-input v-model="shop_info.beneficiary_name"></el-input>
                    </el-form-item>
                    <el-form-item v-if="shop_info.wxradio === '2'" label="受益人身份证号：" prop="beneficiary_id">
                      <el-input v-model="shop_info.beneficiary_id"></el-input>
                    </el-form-item>
                    <el-form-item v-if="shop_info.wxradio === '2'" label="受益人身份证有效期：" prop="beneficiary_id_start_date">
                      <el-col :span="8">
                        <el-date-picker type="date" placeholder="开始日期" v-model="shop_info.beneficiary_id_start_date"
                          style="width: 100%" @change="getDate($event, 'beneficiary_id_start_date')"></el-date-picker>
                      </el-col>
                      <el-col :span="1" style="text-align: center;">—</el-col>
                      <el-col :span="8">
                        <el-date-picker type="date" placeholder="截止日期(长期则不选)"
                          v-model="shop_info.beneficiary_id_expire_in"
                          @change="getDate($event, 'beneficiary_id_expire_in')" style="width: 100%"></el-date-picker>
                      </el-col>
                    </el-form-item>

                    <el-form-item v-if="shop_info.wxradio === '2'" label="授权书：" prop="img_warrant">
                      <uploadImg class="uploadImg" :imgTitle="'warrant'" :mediaNo="shop_info.img_warrant"
                        @getReturn="getReturn" @removeImg="removeImg">
                        <template slot="centerName"> 授权书 </template>
                      </uploadImg>
                    </el-form-item>
                  </el-form>
                </el-scrollbar>
              </div>
            </div>

            <div v-show="active === 3">
              <div :style="el_steps === 'el-steps' ? 'height:400px' : 'height:360px'">
                <el-scrollbar wrapStyle="overflow-x:hidden;" style="height: 100%">
                  <el-divider content-position="left">
                    <h2>资质信息</h2>
                  </el-divider>
                  <el-form label-width="180px" label-position="right" class="form-one">
                    <el-form-item style="margin-top: 30px" label="店铺密码：">{{
                      shop_info.pass_word
                    }}</el-form-item>
                    <el-form-item label="营业执照照片：">
                      {{ shop_info.img_license }}

                      <!-- <img :src="shop_info.img_license
                      ? $url +
                      'media/image/' +
                      shop_info.img_license +
                      '.jpg'
                      : ''
                      " style="height: 660px; width: 450px" alt="" v-show="shop_info.img_license" /> -->
                    </el-form-item>
                    <el-form-item label="店铺名称：">{{
                      shop_info.mch_name
                    }}</el-form-item>
                    <el-form-item label="店铺名称：">{{
                      shop_info.sub_name
                    }}</el-form-item>
                    <el-form-item label="营业执照id：">{{
                      shop_info.license_code
                    }}</el-form-item>
                    <el-form-item label=" 营业执照有效期：">{{ shop_info.license_start_date }}到{{
                      shop_info.license_expire_in
                        ? shop_info.license_expire_in
                        : ""
                    }}</el-form-item>
                    <el-form-item label="店铺地址：">{{
                      shop_info.address
                    }}</el-form-item>

                    <!-- <el-form-item label="商户类型：">
                    {{ getMchType() }}
                  </el-form-item>
                  <el-form-item label="经营范围：">
                    {{ getBusinessScope() }}
                  </el-form-item> -->

                    <el-form-item label="店铺省市区：">{{
                      address_name
                    }}</el-form-item>

                    <el-form-item label="店铺门头照：">
                      {{ shop_info.img_door }}
                      <!-- <img :src="shop_info.img_door
                      ? $url + 'media/image/' + shop_info.img_door + '.jpg'
                      : ''
                      " style="height: 400px; width: 586px" v-show="shop_info.img_door" alt="" /> -->
                    </el-form-item>

                    <el-form-item label="店铺内景照片：">
                      {{ shop_info.img_in_door }}

                      <!-- <img :src="shop_info.img_in_door
                      ? $url +
                      'media/image/' +
                      shop_info.img_in_door +
                      '.jpg'
                      : ''
                      " style="height: 400px; width: 586px" alt="" v-show="shop_info.img_in_door" />-->
                    </el-form-item>
                    <el-form-item label="收银台照片：">
                      {{ shop_info.img_cashier }}

                      <!-- <img :src="shop_info.img_cashier
                      ? $url +
                      'media/image/' +
                      shop_info.img_cashier +
                      '.jpg'
                      : ''
                      " style="height: 400px; width: 586px" v-show="shop_info.img_cashier" alt="" /> -->
                    </el-form-item>
                  </el-form>
                  <el-divider content-position="left">
                    <h2>基础信息</h2>
                  </el-divider>
                  <el-form label-width="180px" label-position="right" ref="wxFormRef" class="form-one">
                    <el-form-item label="法人身份证正面：">
                      {{ shop_info.img_legal_id_front }}

                      <!-- <img :src="shop_info.img_legal_id_front
                      ? $url +
                      'media/image/' +
                      shop_info.img_legal_id_front +
                      '.jpg'
                      : ''
                      " style="height: 225px; width: 330px" v-show="shop_info.img_legal_id_front" alt="" />
                    <img :src="shop_info.img_legal_id_back
                      ? $url +
                      'media/image/' +
                      shop_info.img_legal_id_back +
                      '.jpg'
                      : ''
                      " style="height: 225px; width: 330px" v-show="shop_info.img_legal_id_back" alt="" /> -->
                    </el-form-item>
                    <el-form-item label="法人身份证反面：">{{
                      shop_info.img_legal_id_front
                    }}</el-form-item>
                    <el-form-item label="法人姓名：">{{
                      shop_info.legal_person_name
                    }}</el-form-item>
                    <el-form-item label="法人身份证号：">{{
                      shop_info.legal_person_id
                    }}</el-form-item>

                    <el-form-item label="法人身份证有效期：">
                      {{ shop_info.legal_person_id_start_date }}到{{
                        shop_info.legal_person_id_expire_in
                      }}
                    </el-form-item>
                    <!-- <el-form-item label="联系人：">{{
                    shop_info.contact_man
                  }}</el-form-item> -->
                    <el-form-item label="联系人手机号：">{{
                      shop_info.mobile_no
                    }}</el-form-item>
                    <el-form-item label="店铺电话：">{{
                      shop_info.phone
                    }}</el-form-item>
                    <el-form-item label="服务电话：">{{
                      shop_info.service_phone
                    }}</el-form-item>
                    <el-form-item label="店铺传真：">{{
                      shop_info.fax
                    }}</el-form-item>
                    <el-form-item label="店铺邮箱：">{{
                      shop_info.e_mail
                    }}</el-form-item>
                  </el-form>
                  <el-divider content-position="left">
                    <h2>结算信息</h2>
                  </el-divider>
                  <el-form label-width="180px" label-position="right：" ref="wxFormRef" class="form-one">
                    <el-form-item label="开户银行卡照片：">
                      {{ shop_info.img_bank_card }}
                      <!-- <img :src="shop_info.img_bank_card
                      ? $url +
                      'media/image/' +
                      shop_info.img_bank_card +
                      '.jpg'
                      : ''
                      " style="height: 400px; width: 586px" v-show="shop_info.img_bank_card" alt="" /> -->
                    </el-form-item>
                    <el-form-item label="结算银行卡号：">{{
                      shop_info.account_code
                    }}</el-form-item>
                    <el-form-item label="银行卡账号名称：">{{
                      shop_info.account_name
                    }}</el-form-item>
                    <!-- <el-form-item label="银行名称：">{{
                    shop_info.bank_name
                  }}</el-form-item>
                  <el-form-item label="开户银行名称：">{{
                    shop_info.open_bank_name
                  }}</el-form-item> -->
                    <el-form-item label="开户银行银联号：">{{
                      shop_info.open_bank_code
                    }}</el-form-item>

                    <el-form-item label="服务费率：">
                      {{ shop_info.service_charge }}
                    </el-form-item>
                    <el-form-item label="结算方式：">{{ shop_info.wxradio === '1' ? "法人结算" : shop_info.wxradio ===
                      '2' ? "非法人结算" : "对公结算" }}
                    </el-form-item>
                    <el-form-item label="结算人身份证正面：">
                      {{ shop_info.img_beneficiary_id_front }}
                      <!-- <img :src="shop_info.img_beneficiary_id_front
                      ? $url +
                      'media/image/' +
                      shop_info.img_beneficiary_id_front +
                      '.jpg'
                      : ''
                      " style="height: 225px; width: 330px" v-show="shop_info.img_beneficiary_id_front" alt="" /> -->
                      <!-- <img :src="shop_info.img_beneficiary_id_back
                      ? $url +
                      'media/image/' +
                      shop_info.img_beneficiary_id_back +
                      '.jpg'
                      : ''
                      " style="height: 225px; width: 330px" v-show="shop_info.img_beneficiary_id_back" alt="" /> -->
                    </el-form-item>
                    <el-form-item label="结算人身份证反面：">
                      {{ shop_info.img_beneficiary_id_back }}
                    </el-form-item>
                    <el-form-item label="受益人姓名：">
                      {{ shop_info.beneficiary_name }}
                    </el-form-item>
                    <el-form-item label="受益人身份证号：">{{
                      shop_info.beneficiary_id
                    }}</el-form-item>
                    <el-form-item label="受益人人身份证有效期：">
                      {{ shop_info.beneficiary_id_start_date }}到{{
                        shop_info.beneficiary_id_expire_in
                      }}
                    </el-form-item>

                    <el-form-item v-if="shop_info.wxradio === '2'" label="授权书：">
                      {{ shop_info.img_warrant }}
                      <!-- <img :src="shop_info.img_warrant
                      ? $url +
                      'media/image/' +
                      shop_info.img_warrant +
                      '.jpg'
                      : ''
                      " style="height: 400px; width: 586px" v-show="shop_info.img_warrant" alt="" /> -->
                    </el-form-item>
                  </el-form>
                </el-scrollbar>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部按钮 -->
        <div class="button-bottom">

          <el-button size="medium" v-if="active === 3" type="primary" plain @click="sure = false">信息确认完毕</el-button>
          <!-- <el-button size="medium" @click="pre">打开morf</el-button> -->

          <el-button size="medium" @click="pre">上一步</el-button>
          <!-- disabled = "sure" -->
          <el-button size="medium" type="primary" :disabled="sure" @click="submit">{{ isCreate ? " 商 户 进 件" : "商 户 修 改"
          }}</el-button>
          <!-- <el-button size="medium" type="success" :disabled="sure" @click="submitWX(this.merchant_id)">微 信 进
            件</el-button> -->
          <el-button size="medium" @click="next">下一步</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="选择店铺" :show-close="false" width="40%" :visible.sync="dialogFormVisible" :lock-scroll="true"
      :close-on-click-modal="false">
      <el-form>
        <el-form-item label="店铺已经注创建过，如果需要进件请按照店铺名称搜索到店铺">
          <el-select v-model="merchant_id" filterable placeholder="请选择">
            <el-option v-for="item in mchList" :key="item.merchant_id" :label="item.sub_name" :value="item.merchant_id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="padding-right:10px ;">
        <el-button @click="hideDialog(false)">取 消</el-button>
        <el-button type="primary" @click="hideDialog(true)">确 定</el-button>
      </div>
    </el-dialog>
    <!-- <morf :feed="false" :mch_id="merchant_id" :shopmanage="false" @colse-morf="merfshow = false"></morf> -->
  </div>
</template>
<script>

// eslint-disable-next-line no-unused-vars
import { generateMerchant, merchantPayApply, getServiceCreateMerchant, merchantPayUpdate } from "@/api/service.js";
//eslint-disable-next-line
import { wxGetBankProvince, wxGetBankCity, wxGetBankCode, queryOpenBank, wxMchPayApply } from "@/api/wxService.js";
// eslint-disable-next-line no-unused-vars
import { timeFun, removeEmptyValues } from "@/js/public.js";
import "@/css/global.css";
import { province, map } from "@/js/map";
/* eslint-disable */
import morf from "@/components/morf.vue";
import uploadImg from "@/components/uploadImg.vue";
import mchTable from "./components/mchTable.vue";
// eslint-disable-next-line no-unused-vars
let pinyin = require("js-pinyin");
export default {
  inject: ["reload"],
  components: {
    uploadImg, morf, mchTable
  },
  async created() {
    this.provincearr = province;
    this.map = map;
  },
  watch: {
    "shop_info.account_code": {
      async handler(nbank, obank) {
        if (nbank && nbank.length >= 16) {
          const bank_detailName = await queryOpenBank(nbank);
          //console.log("获取到的银行银联列表：", bank_detailName.data);
          this.bank_option = bank_detailName.data;
          /* if (bank_detailName.data[0]) {
            this.shop_info.open_bank_code = bank_detailName.data[0].bank_alias_code;
          } */
        }
      }
    },
  },
  async mounted() {
    window.localStorage.setItem(
      "pixel",
      window.screen.height * window.screen.width
    );
    var resolution = localStorage.getItem("pixel");
    if (resolution <= 1400 * 900) {
      this.el_steps = "el-steps-sm";
    }
    if (resolution > 1400 * 900) {
      this.el_steps = "el-steps";
    }
    const provinceRes = await wxGetBankProvince();
    this.province_option = provinceRes.data;
  },
  data() {
    return {
      searchMchName: "",//搜索的店铺名
      feedDialog: false,//进件dialog是否显示
      mchList: [], //所有店铺列表
      dialogFormVisible: false, //显示dialog
      merfshow: true,
      isCreate: true,//是否是新建
      merchant_id: "",
      shop_info: {
        //店铺类型
        mch_type: 1,
        //省市区编号
        address_code: "",
        /// 店铺密码
        pass_word: "123",
        merchant_industry: 1,
        /// 店铺全名称 优选易购生活超市-颐和店
        mch_name: "",
        /// 营业执照ID
        license_code: "",
        /// 法人姓名
        legal_person_name: "",
        /// 法人身份证号
        legal_person_id: "",
        /// 联系人 日常联系人通常是业务员
        contact_man: "",
        /// 联系人的手机号码
        mobile_no: "",
        /// 店铺地址
        address: "",
        /// 店铺电话
        phone: "",
        /// 服务电话 给用户联系的电话展示在店铺中
        service_phone: "",
        /// 传真
        fax: "",
        /// 电子邮箱
        e_mail: "",
        /// 结算银行卡的账号名称
        account_name: "",
        /// 结算账号
        account_code: "",
        //开户银行
        bank_name: "",
        //开户银行名称含支行
        open_bank_name: "",
        ///银行卡
        img_bank_card: "",
        ///门头照
        img_door: "",
        //内景
        img_in_door: "",
        //收银台
        img_cashier: "",
        //授权书
        img_warrant: "",
        /// 法人身份证正面人像面
        img_legal_id_front: "",
        /// 法人身份证反面
        img_legal_id_back: "",
        /// 营业执照照片
        img_license: "",
        //受益人
        beneficiary_name: "",
        beneficiary_id: "",
        img_beneficiary_id_front: "", //正面
        img_beneficiary_id_back: "", //反面
        //受益人身份证开始日期截止日期
        beneficiary_id_start_date: "",
        beneficiary_id_expire_in: "",
        //商铺类型
        merchant_type: "",
        //经营范围
        business_scope: "",
        //营业执照开始有效期
        license_start_date: "",
        //营业执照结束有效期
        license_expire_in: "",
        //法人身份证开始有效期
        legal_person_id_start_date: "",
        //法人身份证结束有效期
        legal_person_id_expire_in: "",
        //服务费率
        service_charge: "",
        //是否预授权
        is_pre_auth: 2,
        //开户行银联号
        open_bank_code: "",
        wxradio: "1",
        //开户银行省不是必要字段
        bank_province: "",
        //开户银行市不是必要字段
        bank_city: "",
        //银行别名号
        bank_alias_code: ""
      },
      baserules: {
        mch_type: [
          { required: true, message: "请选择商户类型", trigger: "change" }
        ],
        address_code: [
          { required: true, message: "请选择店铺省市区", trigger: "change" }
        ],
        img_license: [
          { required: true, message: "请上传营业执照", trigger: "change" }
        ],
        pass_word: [
          { required: true, message: "请填写店铺密码", trigger: "change" },
          {
            min: 3,
            max: 10,
            message: "长度在 3 到 10 个字符",
            trigger: "change"
          }
        ],
        is_pre_auth: [
          { required: true, message: "请选择是否预授权", trigger: "change" }
        ],
        mch_name: [
          { required: true, message: "请填写店铺名称", trigger: "change" }
        ],
        sub_name: [
          { required: true, message: "请填写店铺简称", trigger: "change" }
        ],
        license_code: [
          {
            required: true,
            message: "请填写店铺营业执照id",
            trigger: "change"
          }
        ],
        license_start_date: [
          {
            required: true,
            message: "请填写营业执照开始有效期",
            trigger: "change"
          }
        ],
        address: [
          { required: true, message: "请填写店铺地址", trigger: "change" }
        ],
        merchant_type: [
          { required: true, message: "请选店铺择商户类型", trigger: "change" }
        ],
        business_scope: [
          {
            required: true,
            message: "请选择店铺的经营范围",
            trigger: "change"
          }
        ],
        img_door: [
          { required: true, message: "请上传店铺门头照片", trigger: "change" }
        ],
        img_in_door: [
          { required: true, message: "请上传店铺内景照片", trigger: "change" }
        ],
        img_cashier: [
          { required: true, message: "请上传店铺收银台照片", trigger: "change" }
        ]
      },
      legalrules: {
        legal_person_name: [
          { required: true, message: "请填写法人姓名", trigger: "blur" }
        ],
        legal_person_id: [
          { required: true, message: "请填写法人身份证号", trigger: "blur" }
        ],
        img_legal_id_front: [
          {
            required: true,
            message: "请上传法人身份证正面照片",
            trigger: "change"
          }
        ],
        img_legal_id_back: [
          {
            required: true,
            message: "请上传法人身份证反面照片",
            trigger: "change"
          }
        ],
        contact_man: [
          { required: true, message: "请填写联系人姓名", trigger: "blur" }
        ],
        mobile_no: [
          { required: true, message: "请填写联系人电话", trigger: "blur" }
        ],
        legal_person_id_start_date: [
          {
            required: true,
            message: "请选择法人身份证有效期",
            trigger: "change"
          }
        ],
        phone: [
          { required: true, message: "请填写店铺电话", trigger: "blur" }
        ],
        service_phone: [
          { required: true, message: "请填写服务电话", trigger: "blur" }
        ],
        e_mail: [
          { required: true, message: "请填写邮箱", trigger: "blur" }
        ]
      },
      bankrules: {
        account_code: [
          { required: true, message: "请选择结算银行卡号", trigger: "change" }
        ],
        bank_name: [
          { required: true, message: "请选择结算银行名称", trigger: "blur" }
        ],
        open_bank_name: [
          {
            required: true,
            message: "请选择开户银行名称（含支行名称）",
            trigger: "change"
          }
        ],
        img_bank_card: [
          {
            required: true,
            message: "请选择上传银行卡照片",
            trigger: "change"
          }
        ],
        open_bank_code: [
          { required: true, message: "请填写开户银行银联号", trigger: "blur" }
        ],
        service_charge: [
          { required: true, message: "请填写服务费率", trigger: "change" }
        ],
        beneficiary_name: [
          { required: true, message: "请填写受益人名称", trigger: "change" }
        ],
        beneficiary_id: [
          {
            required: true,
            message: "请填写受益人身份证号码",
            trigger: "change"
          }
        ],
        img_beneficiary_id_front: [
          { required: true, message: "请上传受益人身份证", trigger: "change" }
        ],
        beneficiary_id_start_date: [
          {
            required: true,
            message: "请填写受益人身份证开始日期",
            trigger: "change"
          }
        ],
        beneficiary_id_expire_in: [
          {
            required: true,
            message: "请填写受益人身份证截止日期",
            trigger: "change"
          }
        ],
        img_warrant: [
          { required: true, message: "请上传授权书", trigger: "change" }
        ],
        wxradio: [
          {
            required: true,
            message: "请选择受益人是否是法人",
            trigger: "change"
          }
        ],
        account_name: [
          {
            required: true,
            message: "请输入银行卡账户名",
            trigger: "change"
          }
        ],
        bank_province: [
          {
            required: true,
            message: "请选择开户银行省市",
            trigger: "change"
          }
        ]
      },
      merchant_type_options: [
        {
          value: 0,
          label: "小微商户"
        },
        {
          value: 1,
          label: "个体户"
        },
        {
          value: 2,
          label: "企业"
        },
        {
          value: 3,
          label: "事业单位"
        },
        {
          value: 4,
          label: "政府机关"
        },
        {
          value: 5,
          label: "社会组织"
        }
      ],
      el_steps: "",//步骤条样式
      //操作时间
      oper_date: "",
      //状态
      state: "",
      sure: true, //是否确定提交
      /**
       * 当前活动页
       */
      active: 0,
      provincearr: [],
      map: [],
      MCC: [],
      address_name: "",
      city_option: [],
      province_option: [],
      bank_option: [],//银行卡号开户行类别
      open_bank_options: [],//开户银含支行名称
      bank_name_value: ""
    };
  },

  methods: {
    /**
     * 处理商户表格操作
     * @function mchTableAction
     * @param {Object} e - 操作事件对象
     * @param {"submit"|"update"|"wxApply"} e.key - 操作类型
     * @param {Object} e.row - 操作对应的行数据
     * @param {string} e.row.merchant_id - 商户ID
     * @returns {void}
     */
    mchTableAction(e) {
      switch (e.key) {
        case "submit":
          this.createMch(e.row.merchant_id);
          console.log("进件商户ID：", e.row.merchant_id);
          break;
        case "update":
          this.feedDialog = true;//显示进件modal
          this.isCreate = false;
          this.merchant_id = e.row.merchant_id;
          this.shop_info = Object.assign({}, e.row);
          //TODO: 显示dialog之前先获取到商户信息
          // this.shop_info = Object.assign({}, e.row);
          //获取到商户材料 1-》本地是否有 线上是否有 覆盖到本地
          break;
        /* case "wxApply":
          this.merchant_id = e.row.merchant_id;
          this.submitWX(e.row.merchant_id);
          //直接调用微信进件接口
          break; */
      }
    },
    /**
     * 关闭进件弹窗之前的回调
     */
    handleClose() {
      this.feedDialog = false;
      this.active = 0;//重置到第一页
      if (this.merchant_id === "") return;
      else {
        //console.log("进件完成后将进件信息复制一份到本地");
        this.setFeedData(this.merchant_id);
      }

    },
    /**
     * 当radio改变
     * @param res
     */
    wxradioChange(res) {
      if (res === 2) {
        this.shop_info.account_name = "";
        this.shop_info.beneficiary_id = "";
        this.shop_info.beneficiary_name = "";
        this.shop_info.img_beneficiary_id_front = "";
        this.shop_info.img_beneficiary_id_back = "";
        this.shop_info.beneficiary_id_start_date = "";
        this.shop_info.beneficiary_id_expire_in = "";
      } else if (res === 1 || res === 3) {
        this.shop_info.account_name = this.shop_info.legal_person_name;
      }
    },
    /**
     * 开户银行含支行名称修改
     */
    getOpenBnakName() {
      for (var i = 0; i < this.open_bank_options.length; i++) {
        if (this.open_bank_options[i].bank_branch_name === this.shop_info.open_bank_name) {
          this.shop_info.open_bank_code = this.open_bank_options[i].bank_branch_id;
        }
      }
    },
    /**
     * 获取银行含支行名称
     */
    async getOpenBank() {
      /*  var data = {
         province: this.shop_info.bank_province,
         city: this.shop_info.bank_city
       }; */
      const BankCodeRes = await wxGetBankCode(this.shop_info.bank_alias_code, this.shop_info.bank_city);
      this.open_bank_options = BankCodeRes.data;
      /* if (res.resp_data.length > 0) {
        var arr = res.resp_data;
        this.open_bank_options = [];
        if (this.shop_info.bank_name === "其他银行") {
          for (var i = 0; i < arr.length; i++) {
            this.open_bank_options.push({
              label: arr[i].full_name,
              value: arr[i].bank_code
            });
          }
        } else {
          for (var x in arr) {
            if (arr[x].full_name.indexOf(this.shop_info.bank_name) >= 0) {
              this.open_bank_options.push({
                label: arr[x].full_name,
                value: arr[x].bank_code
              });
            }
          }
        }
      } */
    },
    /**
     * 获取所有市
     */
    async getCity() {
      this.city_option = [];
      const CityRes = await wxGetBankCity(this.shop_info.bank_province);
      this.city_option = CityRes.data;
    },
    /**
     * 图片识别组件返回：
     */
    getReturn(res) {
      if (
        (res.title === "beneficiary_zm" && this.shop_info.wxradio === "1")
      ) {
        return;
      }
      switch (res.title) {
        case "yyzz":
          if (res.media_no) {
            this.shop_info.img_license = res.media_no;
          }
          if (res.img_info) {
            this.shop_info.license_start_date = timeFun("yyyy-mm-dd", res.img_info.dateEstablishment);
            if (res.img_info.dateValidity === "无") {
              this.shop_info.license_expire_in = "长期";
            } else {
              this.shop_info.license_expire_in = timeFun("yyyy-mm-dd", res.img_info.dateValidity);
            }
            this.shop_info.mch_name = res.img_info.commpanyName;
            this.shop_info.license_code = res.img_info.licenseCode;
            this.shop_info.address = res.img_info.address;
          } else {
            this.warnMessage("营业执照信息获取失败，请重试");
          }
          break;
        case "zm":
          if (res.media_no) {
            this.shop_info.img_legal_id_front = res.media_no;
          }
          if (res.img_info) {

            this.shop_info.legal_person_name = res.img_info.name;//姓名
            // this.shop_info.img_beneficiary_id_front = res.img_info.name;
            this.shop_info.legal_person_id = res.img_info.number;//身份证号
          } else {
            this.warnMessage("法人身份证正面上传失败，请重试");
          }
          break;
        case "beneficiary_zm":
          if (res.media_no) {
            this.shop_info.img_beneficiary_id_front = res.media_no;
          }
          if (res.img_info) {
            this.shop_info.beneficiary_name = res.img_info.name;
            this.shop_info.beneficiary_id = res.img_info.number;
          } else {
            this.warnMessage("受益人身份证正面上传失败，请重试");
          }
          break;
        case "fm":
          if (res.media_no) {
            this.shop_info.img_legal_id_back = res.media_no;
          }
          if (res.img_info) {
            this.shop_info.legal_person_id_start_date = res.img_info.begin;
            this.shop_info.legal_person_id_expire_in = res.img_info.end;
          } else {
            this.warnMessage("法人身份证反面上传失败，请重试");
          }
          break;
        case "beneficiary_fm":
          if (res.media_no) {
            this.shop_info.img_beneficiary_id_back = res.media_no;
          }
          if (res.img_info) {
            this.shop_info.beneficiary_id_start_date = res.img_info.begin;
            this.shop_info.beneficiary_id_expire_in = res.img_info.end;
          } else {
            this.warnMessage("受益人身份证反面上传失败，请重试");
          }
          break;
        case "bank":
          if (res.media_no) {
            this.shop_info.img_bank_card = res.media_no; //银行卡照片
          }
          if (res.img_info) {
            this.shop_info.account_code = res.img_info.number;
            this.shop_info.bank_name = res.img_info.bank;
          } else {
            this.warnMessage("银行卡号获取失败，请重试");
          }
          break;
        //门头store_entrance
        case "store_entrance":
          if (res.media_no) {
            this.shop_info.img_door = res.media_no;
          }
          break;
        //内部indoor
        case "indoor":
          if (res.media_no) {
            this.shop_info.img_in_door = res.media_no;
          }
          break;
        //收银台cashier
        case "cashier":
          if (res.media_no) {
            this.shop_info.img_cashier = res.media_no;
          }
          break;
        //授权书warrant
        case "warrant":
          if (res.media_no) {
            this.shop_info.img_warrant = res.media_no;
          }
          break;
      }
    },
    /* subStitute(strr) {
      if (
        strr === "长期" ||
        strr === "无" ||
        strr === "年月日" ||
        strr === "" ||
        strr === null ||
        strr === undefined
      ) {
        return "";
      }
      var str = "";
      for (var key in strr) {
        if (key === 4 || key === 7) {
          str += "-";
        } else if (key === 10) {
        } else {
          str += strr[key];
        }
      }
      console.log("str---------------", str);
      return str;
    }, */
    // 删除已经上传的图片
    removeImg(imgTitle) {
      switch (imgTitle) {
        case "fm":
          this.shop_info.img_legal_id_back = "";
          this.shop_info.legal_person_id_start_date = "";
          this.shop_info.legal_person_id_expire_in = "";
          break;
        case "zm":
          this.shop_info.img_legal_id_front = "";
          this.shop_info.beneficiary_name = "";
          this.shop_info.beneficiary_id = "";
          break;
        case "yyzz":
          this.shop_info.img_license = "";
          this.shop_info.license_start_date = "";
          this.shop_info.license_expire_in = "";
          this.shop_info.mch_name = "";
          this.shop_info.address = "";
          this.shop_info.license_code = "";
          break;
        case "bank":
          this.shop_info.img_bank_card = "";
          this.shop_info.account_code = "";
          break;
        case "indoor":
          this.shop_info.img_in_door = "";
          break;
        case "cashier":
          this.shop_info.img_cashier = "";
          break;
        case "store_entrance":
          this.shop_info.img_door = "";
          break;
        case "warrant":
          this.shop_info.img_warrant = "";
          break;
        case "beneficiary_zm":
          this.shop_info.img_beneficiary_id_front = "";
          this.shop_info.beneficiary_name = "";
          this.shop_info.beneficiary_id = "";
          break;
        case "beneficiary_fm":
          this.shop_info.img_beneficiary_id_back = "";
          this.shop_info.beneficiary_id_start_date = "";
          this.shop_info.beneficiary_id_expire_in = "";
          break;
      }
    },
    getDate(date, e) {
      if (date === null) {
        return;
      }
      this.shop_info[e] = this.formatDate(date);
    },

    setDate() { },
    /**
     * 下一步
     */
    next() {
      if (this.active === 0) {
        this.$refs.baseForm.validate((valid) => {
          if (valid) {
            this.active++;
          }
        });
        return;
      }

      if (this.active === 1) {
        this.$refs.legalForm.validate((valid) => {
          if (valid) {
            this.active++;
          }
        });
        return;
      }

      if (this.active === 2) {
        this.$refs.bankForm.validate((valid) => {
          if (valid) {
            this.active++;
          }
        });
      }
      if (this.active >= 3) {
        this.active = 3;
        if (this.shop_info.wxradio === '1') {
          this.shop_info.beneficiary_id = this.shop_info.legal_person_id;
          this.shop_info.beneficiary_name = this.shop_info.legal_person_name;
          this.shop_info.img_beneficiary_id_front =
            this.shop_info.img_legal_id_front;
          this.shop_info.img_beneficiary_id_back =
            this.shop_info.img_legal_id_back;
          this.shop_info.beneficiary_id_start_date =
            this.shop_info.legal_person_id_start_date;
          this.shop_info.beneficiary_id_expire_in =
            this.shop_info.legal_person_id_expire_in;
        }
      }
    },
    /**
     * 上一步
     */
    pre() {
      if (this.active-- < 1) this.active = 0;
    },
    /**
     * 创建商户
     * @param {string} merchant_id - 商户ID
     */
    createMch(merchant_id) {
      console.log("创建商户进件，商户ID：", merchant_id);
      this.merchant_id = merchant_id ? merchant_id : "create0000";
      this.shop_info = {
        //店铺类型
        mch_type: 1,
        //省市区编号
        address_code: "",
        /// 店铺密码
        pass_word: "123",
        merchant_industry: 1,
        /// 店铺全名称 优选易购生活超市-颐和店
        mch_name: "",
        /// 营业执照ID
        license_code: "",
        /// 法人姓名
        legal_person_name: "",
        /// 法人身份证号
        legal_person_id: "",
        /// 联系人 日常联系人通常是业务员
        contact_man: "",
        /// 联系人的手机号码
        mobile_no: "",
        /// 店铺地址
        address: "",
        /// 店铺电话
        phone: "",
        /// 服务电话 给用户联系的电话展示在店铺中
        service_phone: "",
        /// 传真
        fax: "",
        /// 电子邮箱
        e_mail: "",
        /// 结算银行卡的账号名称
        account_name: "",
        /// 结算账号
        account_code: "",
        //开户银行
        bank_name: "",
        //开户银行名称含支行
        open_bank_name: "",
        ///银行卡
        img_bank_card: "",
        ///门头照
        img_door: "",
        //内景
        img_in_door: "",
        //收银台
        img_cashier: "",
        //授权书
        img_warrant: "",
        /// 法人身份证正面人像面
        img_legal_id_front: "",
        /// 法人身份证反面
        img_legal_id_back: "",
        /// 营业执照照片
        img_license: "",
        //受益人
        beneficiary_name: "",
        beneficiary_id: "",
        img_beneficiary_id_front: "", //正面
        img_beneficiary_id_back: "", //反面
        //受益人身份证开始日期截止日期
        beneficiary_id_start_date: "",
        beneficiary_id_expire_in: "",

        //商铺类型
        merchant_type: "",
        //经营范围
        business_scope: "",

        //营业执照开始有效期
        license_start_date: "",
        //营业执照结束有效期
        license_expire_in: "",

        //法人身份证开始有效期
        legal_person_id_start_date: "",
        //法人身份证结束有效期
        legal_person_id_expire_in: "",

        //服务费率
        service_charge: "",
        //是否预授权
        is_pre_auth: 2,
        //开户行银联号
        open_bank_code: "",
        wxradio: "1",
        //开户银行省不是必要字段
        bank_province: ""
      }
      if (this.getFeedData(this.merchant_id)) {
        this.shop_info = {
          ...this.shop_info,
          ...this.getFeedData(this.merchant_id)
        }
      }
      this.feedDialog = true;
      this.isCreate = true;
    },
    /**
     * 模糊查询店铺
     */
    searchMerchant() {
      //console.log("搜索的店铺名：", this.searchMchName);
      this.$refs.mchTableRef.wtyTableIn(this.searchMchName);
    },

    /**
     * 创建商户，商户进件
     */
    async submit() {
      if (this.isCreate === true) {//如果是新建店铺
        const cre = await this.createMerchant();//先创建店铺
        // this.getAll
        if (cre) {//如果返回是true 则表示店铺创建成功
          this.$refs.mchTableRef.getMearchant();//获取全部店铺
          this.applyMerchant();//店铺id已经是获取到的了，可以直接进件
        }//如果创建失败 则不进行后续操作 需要通过选择店铺来进件

      } else {//如果是修改，直接进件
        this.applyMerchant();//店铺id已经是获取到的了，可以直接进件
      }
      //localStorage.setItem("feed_shop_info", JSON.stringify(this.shop_info));

    },
    /**
     * 获取本地存放的进件信息
     * @param {string} merchant_id - 商户ID
     */
    getFeedData(merchant_id) {
      if (merchant_id) {
        let data = localStorage.getItem("feed_shop_info");
        if (data) {
          //let feed_shop_info = {};
          let jpData = JSON.parse(data);
          if (jpData[merchant_id]) return JSON.parse(data)[merchant_id];
          else return false;
          /* feed_shop_info = JSON.parse(data);
          this.shop_info = feed_shop_info; */
        } else return false;
      }
    },
    /**
     * 安装店铺号报错进件信息到本地
     * @param {string} merchant_id - 商户ID
     */
    setFeedData(merchant_id) {
      if (merchant_id) {
        let data = localStorage.getItem("feed_shop_info");
        try {
          if (data) {
            let feed_shop_info = JSON.parse(data);
            feed_shop_info[merchant_id] = this.shop_info;
            localStorage.setItem("feed_shop_info", JSON.stringify(feed_shop_info));
          } else {
            let feed_shop_info = {};
            feed_shop_info[merchant_id] = this.shop_info;
            localStorage.setItem("feed_shop_info", JSON.stringify(feed_shop_info));
          }
        } catch (e) {
          console.log("存储进件信息到本地报错：", e);
        }

        //localStorage.setItem("feed_shop_info", JSON.stringify(this.shop_info));
      }
    },
    /**
     * 删除本地存放的进件信息
     * @param {string} merchant_id - 商户ID
     */
    deleteFeedData(merchant_id) {
      if (merchant_id) {
        let data = localStorage.getItem("feed_shop_info");
        if (data) {
          let feed_shop_info = JSON.parse(data);
          delete feed_shop_info[merchant_id];
          localStorage.setItem("feed_shop_info", JSON.stringify(feed_shop_info));
        }
      }
    },
    /**
     * 创建店铺
     */
    createMerchant() {
      return new Promise(async (resolve, reject) => {
        try {
          this.merchant_id = "";
          this.getDate(new Date(), "oper_date");
          let generateData = {
            address: this.shop_info.address,
            business_scope: "食品销售、日用百货、烟酒销售",
            contacts_man: this.shop_info.contact_man,
            eMail: this.shop_info.e_mail,
            expire_time: this.shop_info.license_expire_in ? this.shop_info.license_expire_in : "",
            fax: this.shop_info.fax,
            latitude: "",
            license_code: await this.$encrypt(this.shop_info.license_code),
            longitude: "",
            mch_name: this.shop_info.mch_name,
            mch_type: this.shop_info.mch_type,
            mobile_no: await this.$encrypt(this.shop_info.mobile_no),
            pass_word: await this.$encrypt(this.shop_info.pass_word),
            phone: this.shop_info.phone,
            pym: pinyin.getCamelChars(this.shop_info.mch_name),
            service_phone: "400-123-4567",
            sub_name: this.shop_info.sub_name
          }
          const generateRes = await generateMerchant(removeEmptyValues(generateData));
          if (!generateRes.merchant_id) {
            this.shopDialog();
            resolve(false);
          }
          this.merchant_id = generateRes.merchant_id;
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });

    },
    /**
    * 商户进件
    */
    async applyMerchant() {
      const jjData = { //进件数据
        merchant_id: this.merchant_id,
        address: this.shop_info.address,
        address_code: this.shop_info.address_code,
        merchant_type: this.shop_info.merchant_type,
        merchant_industry: 1, //行业类型
        merchant_name: this.shop_info.mch_name,
        sub_name: this.shop_info.sub_name,
        license_code: this.shop_info.license_code, //营业执照编号
        image_license: this.shop_info.img_license, //营业执照照片
        image_legal_person_front: this.shop_info.img_legal_id_front, //正面
        image_legal_person_back: this.shop_info.img_legal_id_back, //反面
        image_store_front: this.shop_info.img_door, //门头
        image_store_in: this.shop_info.img_in_door, //内景
        image_cash_desk: this.shop_info.img_cashier, //收银
        image_bank_front: this.shop_info.img_bank_card, //银行卡
        image_legal_auth: this.shop_info.img_warrant, //授权函
        image_settler_front: this.shop_info.img_beneficiary_id_front, //结算人身份证正面
        image_settler_back: this.shop_info.img_beneficiary_id_back, //结算人身份证反面
        settlement_type: this.shop_info.wxradio, //结算方式
        mobile_no: this.shop_info.mobile_no,
        service_phone: this.shop_info.phone,
        e_mail: this.shop_info.e_mail,
        legal_period_begin: this.shop_info.legal_person_id_start_date,//法人身份证开始有效期
        legal_person_name: this.shop_info.legal_person_name,//法人姓名
        legal_person_id: this.shop_info.legal_person_id,//法人身份证id
        license_period_begin: this.shop_info.license_start_date, //营业执照开始有效期
        license_period_end: this.shop_info.license_expire_in, //营业执照截止有效期
        legal_period_end: this.shop_info.legal_person_id_expire_in, //法人身份证截止有效期
        settler_id: this.shop_info.beneficiary_id, //结算人证件id
        settler_period_begin: this.shop_info.beneficiary_id_start_date, //结算人证件有效期
        settler_period_end: this.shop_info.beneficiary_id_expire_in, //结算人证件有效期
        open_bank_name: this.shop_info.bank_name, //开户银行含支行名称
        open_bank_code: this.shop_info.open_bank_code,
        bank_account_name: this.shop_info.account_name, //开户名称
        bank_account_no: this.shop_info.account_code, // 银行账号
        rate: this.shop_info.service_charge
      }
      if (this.isCreate) {//新建
        const payApplyRes = await merchantPayApply(jjData);
        if (payApplyRes.state === true) {//进件成功
          this.successMessage(payApplyRes.message);
          let createData = this.getFeedData("create0000");
          if (createData.license_code === this.shop_info.license_code) {
            this.deleteFeedData("create0000");//删除本地存储的进件信息
            this.deleteFeedData(this.merchant_id);//删除本地存储的进件信息
            this.merchant_id = "";//重置merchant_id
            this.dialogFormVisible = false;
          }
        } else this.setFeedData(this.merchant_id);//如果进件识别，保存进件信息到本地
      } else {// 修改
        const updateRes = await merchantPayUpdate(jjData);
        if (updateRes.state === true) this.successMessage(updateRes.message);
        else this.setFeedData(this.merchant_id);//如果进件识别，保存进件信息到本地

        this.deleteFeedData(this.merchant_id);//删除本地存储的进件信息
        this.merchant_id = "";//重置merchant_id
        this.dialogFormVisible = false;

      }

    },

    /**
     * 显示dialog
     */
    async shopDialog() {
      this.dialogFormVisible = true;
      const result = await getServiceCreateMerchant();
      if (this.testR(result)) {
        this.mchList = result.data.resp_data;
      }
    },
    hideDialog(v) {
      if (v === false) {
        this.merchant_id = "";
        this.warnMessage("取消选择，取消进件！！！");
      } else {
        this.applyMerchant();
      }
      this.dialogFormVisible = false;
    },




    //资质类型
    getMchType() {
      for (var i = 0; i < 3; i++) {
        if (this.merchant_type_options[i].value === this.shop_info.merchant_type) {
          return this.merchant_type_options[i].label;
        }
      }
    },
    //经营范围
    getBusinessScope() {
      for (var i = 0; i < this.MCC.length; i++) {
        if (this.MCC[i].value === this.shop_info.business_scope) {
          return this.MCC[i].label;
        }
      }
    },
    /**
     * 店铺省市区修改
     */
    async shophandleChange(e) {
      if (e.length === 0) {
        return;
      }
      this.shop_info.address_code = e[2];
      this.address_name = this.map[e[2]];
    },
    /* reset() {
      this.$confirm("执行重置操作所有内容将被清空，确定继续吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.reload();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    } */
  }
};
</script>
<style lang="less" scoped>
/* #bank_name {
  min-width: 460px !important;
  width: 460px !important;
}
 */
/deep/.el-form-item__content {
  max-height: 155px;
}

.el-input {
  width: 460px;
}

/deep/#bank_select>.el-input {
  max-width: 150px !important;
  overflow: hidden;
}

.div-item {
  display: inline-block;
  width: 33%;
  height: 40px;
  text-align: center;
  margin-bottom: 10px;
  line-height: 2.5;
  cursor: pointer;
}

.fa {
  width: 100%;
  height: 100%;
  background-color: #fff;
  min-height: 585px;
  display: flex;
  align-items: center;
  overflow-x: hidden;
  flex-direction: column;
}

.el-steps-fa {
  width: 70%;
  height: 65px;
  position: absolute;
  top: 0px;
  z-index: 9;
  /* background-color: #f9f9f9; */
  padding: 0 20px;
}

.el-steps {
  margin-top: 10px;
}

.el-steps-sm {
  transform: scale(0.8, 0.8);
  margin-top: 20px;
}

.el-step {
  height: 60px;
}

.box {
  width: 100%;
  background-color: #fff !important;
  line-height: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 580px;
  position: relative;
}

.box-small {
  height: 600px;
}

.el-form-info .el-form-item:nth-child(2n + 2) {
  margin-left: 30px;
}

.el-select {
  width: 100%;
}

.uploadImg {
  width: 110px;
  height: 150px !important;
}

.fa-el-form {
  width: 220px;
  height: 160px;
}

.card-form {
  display: inline-block;
  width: 832px;
  height: 400px;
  padding: 10px;
  margin-top: 50px;
}

.button-bottom {
  width: 60%;
  display: flex;
  justify-content: right;
  margin: 20px 0 0 0;
}

.qualification-type-select {
  width: 200px;
}

.el-cascader-panel {
  height: 300px !important;
}

/deep/.el-cascader.el-cascader-panel {
  height: 300px !important;
}

.el-form-pc {
  height: 672px;
}

h2 {
  margin: 0;
  padding: 0;
}

.form-one {
  color: rgb(1, 75, 153);
}
</style>
